import {AxiosInstance} from "axios";
import {getAxiosAdminOrganizationRequest} from "@API";

export const getOrganizationPolicyEndpoint = async (orgId: string, type: string): Promise<any> => {
    const policyRequest: AxiosInstance = getAxiosAdminOrganizationRequest();
    return await policyRequest.get(`/${orgId}/policies/${type}`);
};
